import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FileSelectEvent } from 'primeng/fileupload';
import { EoBaseFormControlComponent } from '../eo-base-form-control/eo-base-form-control.component';

@Component({
  selector: 'eo-file-upload-base',
  templateUrl: './eo-file-upload-base.component.html',
  styleUrl: './eo-file-upload-base.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EoFileUploadBaseComponent),
      multi: true,
    },
  ],
})
export class EoFileUploadBaseComponent extends EoBaseFormControlComponent {
  @Input() chooseLabel: string = 'Επιλογή';
  @Input() chooseIcon?: string;
  @Input() chooseStyleClass?: string;
  @Input() cancelLabel: string = 'Αφαίρεση';
  @Input() cancelIcon = 'pi pi-times-circle';
  @Input() cancelStyleClass = 'p-button-outlined p-button-danger';
  @Input() accept: string = '.pdf, .jpeg, .pjpeg, .jpg, .gif, .x-png, .png';
  @Input() maxFileSize?: number;
  @Input() fileLimit?: number;
  @Input() invalidFileSizeMessageSummary?: string;
  @Input() invalidFileSizeMessageDetail?: string;
  @Input() invalidFileTypeMessageSummary?: string;
  @Input() invalidFileTypeMessageDetail?: string;

  @Input()
  invalidFileLimitMessageSummary = `Έχετε υπερβεί τον μέγιστο αριθμό αρχείων.`;
  @Input() invalidFileLimitMessageDetail = '';

  @Input() multiple = false;
  @Input() uploadedFiles: any[] = [];

  @Output() select = new EventEmitter<File[]>();
  @Output() removePending = new EventEmitter<File>();
  @Output() clearPending = new EventEmitter<File[]>();
  @Output() removeUploaded = new EventEmitter<File>();
  @Output() clearUploaded = new EventEmitter<File[]>();

  constructor() {
    super();
  }

  public files: File[] = [];

  protected onFilesSelect($event: FileSelectEvent) {
    this.files = $event.currentFiles;
    this.formControl?.setValue(this.files);
    this.select.emit(this.files);
  }

  protected showDownloadFile(): boolean {
    return this.uploadedFiles?.length > 0;
  }

  onFileRemove() {
    this.formControl?.setValue(null);
    this.files = [];
  }

  hasFiles(): boolean {
    return this.files?.length > 0 || this.uploadedFiles?.length > 0;
  }
}
